<template>
    <div class="mb-1">
        <v-row class="no-frame">
            <v-col class="no-frame mr-1 lm-border pa-3 col-8">
                <v-row class="no-frame" v-for="(role,index) in roles" :key="index">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            v-model = "filter.role[role.id]"
                            :label  = "role.name"
                            class   = "mt-0 role-label"
                            :ripple = "false"
                            @change = "onChanged"
                            hide-details
                        />
                        <c-tag
                            class="mt-2"
                            :label="role.label"
                        />
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="no-frame lm-border pa-3 ml-1 ">
                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "aktiv"
                            v-model = "filter.active"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onChanged"
                            hide-details
                        />
                    </v-col>
                </v-row>
                <!--
                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   ="umfirmiert"
                            v-model = "filter.renaming"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onChanged"
                            hide-details
                        />
                    </v-col>
                </v-row>
                -->
                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "inaktiv"
                            v-model = "filter.inactive"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onChanged"
                            hide-details
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <v-col class="no-frame mt-2 lm-border pa-3">
                <c-customer-select
                    label   = "Kunde"
                    v-model = "filter.customer"
                    hide-details
                    class="pb-2"
                    @change="onCustomerChanged"
                />
            </v-col>
        </v-row>

    </div>
</template>

<script>

import Company         from "@/modules/msd/company/common/service/Company";
import CTag            from "@/modules/core/components/utils/CTag";
import CCustomerSelect from "@/modules/msd/company/customer/components/controlls/CCustomerSelect";

const roles = [
    Company.roles.facilitymanagement,
    Company.roles.maintenance,
    Company.roles.escalation,
    Company.roles.manufacturer,
    Company.roles.facilityAdmin,
    Company.roles.execution,
    Company.roles.onlyComponents,
];

const defaultFilter = {
    active          : true,
    inactive        : false,
    renaming         : false
}


export default {
    name: "CServiceFilter",
    components: {
        CCustomerSelect,
        CTag
    },

    data: () => ({
        defaultFilter: [],
        filter: {
            role    : [],
            active  : defaultFilter.active,
            inactive: defaultFilter.inactive,
            renaming : defaultFilter.renaming
        }
     }),

    created() {
        this.defaultFilter[Company.roles.facilitymanagement] = true;
        this.defaultFilter[Company.roles.maintenance] = true;
        this.defaultFilter[Company.roles.escalation] = true;
        this.defaultFilter[Company.roles.inspection] = true;
        this.defaultFilter[Company.roles.manufacturer] = false;
        this.defaultFilter[Company.roles.facilityAdmin] = true;
        this.defaultFilter[Company.roles.execution] = true;
        this.defaultFilter[Company.roles.onlyComponents] = true;

        this.clearFilter();
    },

    computed: {
        roles () {
            return this.$store.getters.companyRoles.filter (role => roles.includes(role.id));
        }
    },

    methods: {
        onChanged() {
            this.$emit("changed", this.filter);
        },

        onCustomerChanged () {
            this.$emit("customer", this.filter.customer);
        },

        filterOn() {
            let on = this.filter.active !== defaultFilter.active
                || this.filter.inactive !== defaultFilter.inactive
                || this.filter.renaming !== defaultFilter.renaming
            ;

            if (on) {
                return true;
            }

            let i = this.filter.role.length;
            while (i--) {
                if (this.filter.role [i] !== this.defaultFilter [i]) {
                    return true;
                }
            }

            return false
        },

        clearFilter() {
            this.filter.role = Array.from(this.defaultFilter);
            this.filter.active = defaultFilter.active;
            this.filter.inactive = defaultFilter.inactive;
            this.filter.renaming = defaultFilter.renaming;
        },

        hasRole (item, type) {
            return item.roles.find(role => role.id === type);
        },

        matchStatus(item) {
            if (this.filter.active) {
                if (item.status.id === Company.status.active) {
                    return true;
                }
            }

            if (this.filter.inactive) {
                if (item.status.id === Company.status.inactive) {
                    return true;
                }
            }

            if (this.filter.renaming) {
                if (item.status.id === Company.status.renaming) {
                    return true;
                }
            }

            return false;
        },

        matchRole(item) {
            let i = 0;
            for (i = 0; i < this.filter.role.length; i++) {
                if (this.filter.role[i]) {
                    const role = this.hasRole(item, i);
                    if (role) {
                        return true;
                    }
                }
            }

            return false;
        },

        match(item) {
            return this.matchRole(item) && this.matchStatus(item);
        }
    }
}
</script>

<style scoped>

.role-label {
    width: 250px;
}

</style>